import { Link } from "react-router-dom";
import { InkCharacter } from "@/components/InkCharacter";

export const AuthShell = ({ title, sub, children, footer }) => (
  <div className="min-h-screen bg-[#FDFBF7] px-6 py-8 sm:px-10">
    <div className="mx-auto w-full max-w-md">
      <Link to="/welcome" aria-label="Ink Genius home" className="flex justify-center"><InkCharacter size="md" /></Link>
      <h1 className="ig-rise mt-8 text-4xl font-semibold leading-tight text-[#2C1810]">{title}</h1>
      {sub && <p className="ig-rise ig-d1 mt-2 text-sm leading-relaxed text-[#6E5549]">{sub}</p>}
      <div className="ig-rise ig-d2 mt-8">{children}</div>
      {footer && <div className="mt-8 text-center text-sm text-[#6E5549]">{footer}</div>}
    </div>
  </div>
);
